import { ClipLoader } from "react-spinners"
import { useContext, useEffect } from "react"
// mine:
import UI from "@/app/lib/ui/ui"
import GameBox from "@/app/components/GameBox"
import Ingredients from "@/app/components/Ingredients"
import MainTitle from "@/app/components/MainTitle"
import RecipeTitle from "@/app/components/RecipeTitle"
import IngredientsTitle from "@/app/components/IngredientsTitle"
import { StoryGameState } from "@/app/lib/game-state/story-game-state"
import { AnyGameObj } from "@/app/lib/game-state/game-types"
import { Contexts } from "@/app/components/Context"
// styles
import animation from "@/app/styles/animation.module.css";



type CoreProps = {
    subtitle: string,
    isLoaded: boolean
}

export default function Core({ subtitle, isLoaded } : CoreProps) {

    const activeGame: AnyGameObj | null = useContext(Contexts.ActiveGame);
    const ui: UI | null = useContext(Contexts.UI);
    if (!activeGame || !ui) {
        console.warn('bad context in Core')
        return;
    }

    // gameBoxKey is managed by UI, we need it to reset when the level/mode changes
    // but we otherwise need it to be stable until UI decides to nominally change it (e.g., on "reset level")
    useEffect(() => {
        const gameKeyFromLevel = activeGame.state instanceof StoryGameState
        ? activeGame.state.levelID
        : 'pyramid'

        ui.setGameBoxKey(gameKeyFromLevel);
    }, [ui.path]) // path is an appropriate proxy for the level

    return (
        <>
            <div className={`
                headerArea
                ${animation.fadeIn}
            `}>
                <MainTitle 
                    subtitle={subtitle}
                />      
            </div>

            {isLoaded
            ?
                <>
                {/* GameBox animations are handled internally
                To allow fade on level change in story*/}
                <div className='gameArea'>
                    <GameBox 
                        key={ui.gameBoxKey}
                    />
                </div>

                <div className={`
                    recipeTitle
                    ${animation.fadeIn}  
                `}>
                    <RecipeTitle />
                </div>
                
                <div className={`
                    ingredientsTitle
                    ${animation.fadeIn}
                `}>
                    <IngredientsTitle/>
                </div>

                {/* Ingredients also manage their own animations */}
                <div className='ingredientsArea'>
                    <Ingredients />
                </div>
                </>
            :
                <div className='gameArea'>
                    <div className='clipLoader'>
                        <ClipLoader
                            color="#f6f8dd"
                            size={50}
                        />
                    </div>
                </div>
        }
        </>
    )
}